import { useState } from "react";
import { CreateRoleModel } from "@core/model/query-model-role";
import { useQyCreateRole, useQyGetRole } from "@core/query/role.query";
import { LabelValue } from "@shared/models/label-value.interface";
import { useNotificationContext } from "@shared/ui/notification/notification.context";

export const useFormDropdownRole = () => {
  const { showWarning, showSuccess } = useNotificationContext();
  const [sidebar, setSidebar] = useState(false);
  const [filter, setFilter] = useState("");
  const [newRole, setNewRole] = useState<CreateRoleModel>({
    name: "",
    description: "",
  });
  const [isCreating, setIsCreating] = useState(false);

  const handleFilterInput = (event: any) => {
    if (event.key === "Enter") {
      setNewRole({
        name: filter,
        description: "",
      });
      setSidebar(true);
    }
  };
  const handleAdd = () => {
    if (!newRole.name) {
      showWarning("Please fill in Role details");
      return;
    }
    setIsCreating(true);
    addRole(newRole);
  };

  const handleAddApiSuccess = () => {
    showSuccess(
      "New Role is added. Check and select the Role in the form."
    );
    setSidebar(false);
    setIsCreating(false);
  };
  const handleAddApiError = () => {
    setIsCreating(false);
  };
  const { mutate: addRole } = useQyCreateRole(
    handleAddApiSuccess,
    handleAddApiError
  );
  const { data: roleResponse } = useQyGetRole('');
  const mappedRole = (roleResponse?.data || []).map(
    (item) =>
      ({
        label: item.name,
        value: item.code,
      } as LabelValue)
  );

  return {
    sidebar,
    filter,
    newRole,
    mappedRole,
    isCreating,
    roleResponse,
    setSidebar,
    setFilter,
    setNewRole,
    handleFilterInput,
    handleAdd,
    addRole,
  };
};